import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import { Button } from '../ui/button';

export const PageHero = ({ 
  title, 
  subtitle, 
  backgroundImage, 
  showCTA = true, 
  ctaText = 'Termin vereinbaren',
  ctaLink = '/termin'
}) => {
  return (
    <section className="page-hero">
      {/* Background - Priority loading für Hero */}
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt=""
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Overlay */}
      <div className="page-hero-overlay" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-4 leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg md:text-xl text-white/90 mb-6 max-w-2xl mx-auto leading-relaxed">
              {subtitle}
            </p>
          )}
          {showCTA && (
            <Link to={ctaLink}>
              <Button size="lg" className="bg-[#edd68d] hover:bg-[#d4c17d] text-[#032925] font-semibold px-8 rounded-full shadow-lg shadow-black/30">
                <Calendar className="w-5 h-5 mr-2" />
                {ctaText}
              </Button>
            </Link>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
